import SamplePageContainer from "../../component/sample-page/SamplePage"

const SamplePage = () => {
  return (
    <div className='page-body'>
      <SamplePageContainer />
    </div>
  )
}

export default SamplePage